import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "./ai-build-complete.step.scss";

export const AiBuildCompleteStep = ({ buildResult }) => {
  const title = buildResult?.title;
  const stats = buildResult?.stats;
  const heading = buildResult?.replacedExisting
    ? "Course Replaced"
    : "Course Built Successfully";

  return (
    <div className="ai-build-complete-step">
      <FontAwesomeIcon
        icon="fa-regular fa-circle-check"
        className="ai-build-complete-step__icon"
      />
      <h2>{heading}</h2>
      {title && <p className="ai-build-complete-step__title">{title}</p>}
      {stats && (
        <p>
          {stats.units} {stats.units === 1 ? "unit" : "units"}, {stats.lessons}{" "}
          {stats.lessons === 1 ? "lesson" : "lessons"}, {stats.activities}{" "}
          {stats.activities === 1 ? "activity" : "activities"}
          {(stats.unresolvedCount ?? 0) > 0
            ? ` (${stats.unresolvedCount} unresolved)`
            : ""}
        </p>
      )}
    </div>
  );
};
